import { useMutation } from "react-query";
import { TextInput, Flex, PrimaryButton, SubText } from "@base-ui";
import { LoadingWithSpinner } from "@animation-ui";
import VideoUploader from "./VideoUploader";
import { uploadPrivateMedia } from "@media";
import { translateError } from "utils/errors";
import { closePopup } from "utils/events";
import { debounce } from "utils/debounce";
import { useAuthContext } from "@authentication/context";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function UploadVideoContent(props) {
  var selectVideo = props.selectVideo,
    setActiveVideo = props.setActiveVideo,
    activeVideo = props.activeVideo,
    description = props.description,
    setDescription = props.setDescription;
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var _useMutation = useMutation(function () {
      return uploadPrivateMedia(activeVideo, description, authTicket);
    }, {
      onSuccess: function onSuccess(data) {
        selectVideo({
          alt: data[0].alt,
          src: data[0].url
        });
      }
    }),
    uploadMedia = _useMutation.mutate,
    error = _useMutation.error,
    uploading = _useMutation.isLoading;
  var debouncedTextUpdate = debounce(setDescription, [500]);
  var errorMessage = error && /*#__PURE__*/_jsx(SubText, {
    children: "".concat(translateError(error), ". Kunde inte ladda upp videon")
  });
  var disableUpload = !(activeVideo && (description === null || description === void 0 ? void 0 : description.trim().length) >= 10);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TextInput, {
      id: "add-video-description",
      value: description,
      autoFocus: true,
      mt: "10px",
      placeholder: "Beskriv videon...",
      label: "Fyll i en videobeskrivning f\xF6r synskadade",
      onChange: debouncedTextUpdate
    }), /*#__PURE__*/_jsx(VideoUploader, {
      activeVideo: activeVideo,
      setActiveVideo: setActiveVideo
    }), errorMessage, /*#__PURE__*/_jsxs(Flex.Row, {
      justifyContent: "flex-end",
      m: "0",
      children: [/*#__PURE__*/_jsx(PrimaryButton, {
        id: "cancel-upload-video",
        onClick: closePopup,
        mr: "10px",
        width: "130px",
        children: "Avbryt"
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        id: "upload-video",
        title: disableUpload ? "Du behöver välja en video, en presentationsbild och fylla i en beskrivning" : undefined,
        width: "160px",
        disabled: disableUpload,
        onClick: uploadMedia,
        children: "V\xE4lj video"
      }), uploading && /*#__PURE__*/_jsx(LoadingWithSpinner, {
        label: "Laddar upp video...",
        width: "fit-content",
        ml: "15px"
      })]
    })]
  });
}